import { render, staticRenderFns } from "./MySponsor.vue?vue&type=template&id=6c023a94&scoped=true"
import script from "./MySponsor.vue?vue&type=script&lang=js"
export * from "./MySponsor.vue?vue&type=script&lang=js"
import style0 from "./MySponsor.vue?vue&type=style&index=0&id=6c023a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c023a94",
  null
  
)

export default component.exports